<template>
<div>

<MyApplication></MyApplication>
</div>
</template>

<script>
import MyApplication from "../../components/Applicant/MyApplication.vue";



export default {

  components: {
 MyApplication
  },
  created() {

  }
};
</script>

<style scoped>


                       
</style>